/**
 * appleAuthService — Sign in with Apple (native iOS only via Capacitor).
 * Apple only provides name + email on the FIRST sign-in; subsequent sign-ins
 * return null for both. The backend handles this gracefully.
 */

export async function nativeAppleSignIn() {
  const { SignInWithApple } = await import('@capacitor-community/apple-sign-in');

  const result = await SignInWithApple.authorize({
    clientId: 'com.kynaixsports',
    redirectURI: 'https://www.kynaixsports.com',
    scopes: 'email name',
    state: Math.random().toString(36).substring(2),
  });

  const { identityToken, givenName, familyName } = result.response;

  if (!identityToken) throw new Error('Apple Sign-In did not return an identity token');

  return {
    identityToken,
    firstName: givenName || null,
    lastName: familyName || null,
  };
}
